module.exports = __webpack_public_path__ + "static/media/stepper-pending.5707f295.svg";